import React from 'react';
import { ResponsiveContainer, FunnelChart, Funnel, Tooltip, LabelList, Cell, Legend } from 'recharts';

import { PyramidData } from './data';
import { useStateContext } from '../../contexts/ContextProvider';
import { ChartsHeader } from '../../components';

export const Pyramid = () => {
  const { currentMode } = useStateContext();

  const colors = ['#8884d8', '#82ca9d', '#ffc658', '#ff8042', '#8dd1e1', '#a4de6c'];

  return (
    <div className="m-4 md:m-10 mt-24  p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl">
      <ChartsHeader category="Pirâmide" title="Gráfico de Comparação de Alimentos" />
      <div className="w-full" style={{ width: '100%', height: 360, background: currentMode === 'Dark' ? '#33373E' : '#fff', padding: 8, borderRadius: 6 }}>
        <ResponsiveContainer width="100%" height="100%">
          <FunnelChart>
            <Tooltip contentStyle={{ backgroundColor: currentMode === 'Dark' ? '#1f2937' : '#fff', borderRadius: 6 }} />
            <Legend wrapperStyle={{ color: currentMode === 'Dark' ? '#eee' : '#333' }} />
            <Funnel dataKey="y" data={PyramidData} isAnimationActive>
              {PyramidData.map((entry, idx) => (
                <Cell key={`cell-${idx}`} fill={colors[idx % colors.length]} />
              ))}
              <LabelList dataKey="text" position="inside" />
            </Funnel>
          </FunnelChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
